import { TableCell } from "@tiptap/extension-table";

const TableCellExtend = TableCell.extend({
  addOptions() {
    return {
      ...this.parent?.(),
      allowTableModification: false,
    }
  },

  renderHTML({ node, HTMLAttributes }) {
    const actions = [
      "mouseenter->advanced-editor#handleHoverTableCell",
      "mouseleave->advanced-editor#handleColMouseLeave",
      "focus->advanced-editor#handleCellClick",
    ];
    if (this.options.allowTableModification) {
      HTMLAttributes["data-action"] = actions.join(" ");
    }
    HTMLAttributes.tabindex = 0;
    return this.parent?.({ node, HTMLAttributes });
  },
});

export default TableCellExtend;
